import type { TList } from '@/types/shared-types'
import type { TIconList } from '@/types/shared-props'
import type { IDrawer } from '@/components/UiDrawer/UiDrawer.types'

export const useOurApproach = () => {
  const { t } = useI18n()

  const certificationList: TList = {
    icon: {
      url: '/icons/icon-checkmark-light-violet.svg',
      alternative: '',
      width: '40',
      height: '40',
    },
    type: 'checkmark',
    layout: '',
    items: [
      {
        title: t('ourApproach.sectionBcorp.certification.text1'),
      },
      {
        title: t('ourApproach.sectionBcorp.certification.text2'),
      },
      {
        title: t('ourApproach.sectionBcorp.certification.text3'),
      },
    ],
  }

  const ethicsList: TIconList[] = [
    {
      'text': t('ourApproach.sectionEthics.text1'),
      'icon': {
        'url': '/icons/icon-group-people.svg',
        'alternative': '',
        'width': '72',
        'height': '72',
      },
    },
    {
      'text': t('ourApproach.sectionEthics.text2'),
      'icon': {
        'url': '/icons/icon-signpost.svg',
        'alternative': '',
        'width': '72',
        'height': '72',
      },
    },
  ]

  const companyValuesDrawer: IDrawer[] = [
    {
      header: t('ourApproach.sectionValues.drawer[0].header'),
      description: t('ourApproach.sectionValues.drawer[0].description'),
      icon: '/icons/icon-drawer-agency.svg',
    },
    {
      header: t('ourApproach.sectionValues.drawer[1].header'),
      description: t('ourApproach.sectionValues.drawer[1].description'),
      icon: '/icons/icon-drawer-respect.svg',
    },
    {
      header: t('ourApproach.sectionValues.drawer[2].header'),
      description: t('ourApproach.sectionValues.drawer[2].description'),
      icon: '/icons/icon-drawer-responsibility.svg',
    },
    {
      header: t('ourApproach.sectionValues.drawer[3].header'),
      description: t('ourApproach.sectionValues.drawer[3].description'),
      icon: '/icons/icon-drawer-development.svg',
    },
    {
      header: t('ourApproach.sectionValues.drawer[4].header'),
      description: t('ourApproach.sectionValues.drawer[4].description'),
      icon: '/icons/icon-drawer-cooperation.svg',
    },
  ]

  const irregularitiesDrawer1:IDrawer[] = [
    {
      header: t('ourApproach.sectionIrregularities.drawer1[0].header'),
      description: t('ourApproach.sectionIrregularities.drawer1[0].description'),

    },
    {
      header: t('ourApproach.sectionIrregularities.drawer1[1].header'),
      description: t('ourApproach.sectionIrregularities.drawer1[1].description'),
    },
    {
      header: t('ourApproach.sectionIrregularities.drawer1[2].header'),
      description: t('ourApproach.sectionIrregularities.drawer1[2].description'),
    },
  ]

  const irregularitiesDrawer2:IDrawer[] = [
    {
      header: t('ourApproach.sectionIrregularities.drawer2[0].header'),
      description: t('ourApproach.sectionIrregularities.drawer2[0].description'),
    },
  ]

  return {
    certificationList,
    ethicsList,
    companyValuesDrawer,
    irregularitiesDrawer1,
    irregularitiesDrawer2,
  }
}
